import { MessageSquare, Lock } from 'lucide-react';

const ChatToggleButton = ({ canUseChat, setIsOpen, unreadCount }) => (
  <button
    onClick={() => canUseChat ? setIsOpen(true) : null}
    className={`fixed bottom-6 right-6 z-50 p-4 rounded-full shadow-lg transition-all duration-200 ${
      canUseChat
        ? 'bg-[#ffd108] hover:bg-[#e5bc07] text-black'
        : 'bg-gray-400 cursor-not-allowed'
    }`}
    title={canUseChat ? 'Open Chat' : 'Upgrade to use Chat'}
  >
    {canUseChat ? (
      <MessageSquare className="h-6 w-6" />
    ) : (
      <Lock className="h-6 w-6" />
    )}
    {unreadCount > 0 && canUseChat && (
      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
        {unreadCount > 9 ? '9+' : unreadCount}
      </span>
    )}
  </button>
);

export default ChatToggleButton;
